/**
 * Сенсоры перетаскивания — одни для списка столбцов и канбана
 * (docs/08-mobile-roadmap.md, M2–M3).
 *
 * Мышь и палец разделены, потому что им нужно разное:
 * - мышь: порог 6 px — без него клик по кнопке внутри строки читается
 *   как начало перетаскивания, и обработчик не срабатывает;
 * - палец: долгое нажатие 250 мс с допуском 5 px — иначе обычный свайп,
 *   которым листают список или доску, хватал бы карточку.
 * Прежний PointerSensor с порогом по расстоянию на телефоне не давал
 * прокручивать: любое движение пальца по карточке становилось переносом.
 *
 * Клавиатура — наравне с мышью и пальцем: перетаскивание только указателем
 * недоступно для тех, кто им не пользуется.
 */

import {
  KeyboardSensor,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
  type KeyboardCoordinateGetter,
} from "@dnd-kit/core";

export const TOUCH_DELAY_MS = 250;

export function useDndSensors(coordinateGetter: KeyboardCoordinateGetter) {
  return useSensors(
    useSensor(MouseSensor, { activationConstraint: { distance: 6 } }),
    useSensor(TouchSensor, { activationConstraint: { delay: TOUCH_DELAY_MS, tolerance: 5 } }),
    useSensor(KeyboardSensor, { coordinateGetter }),
  );
}
